import { Id } from '../utils/id.interface';


export class IconsSet<D extends Id> implements IconSetArgs<D>  {
   static readonly pool: IconsSet<Id>[] = [];

   readonly getSvg: (val: D) => string;
   readonly getTitle: (val: D) => string;
   readonly objects: D[];
   readonly id: string;
   
   constructor({ getSvg, getTitle, objects, id }: IconSetArgs<D>) {
      this.objects = objects;
      this.getTitle = getTitle;
      this.getSvg = getSvg;
      this.id = id;
      IconsSet.pool.push(this);
   }
}


export interface Icon extends Id {
   svg: string;
   title?: string | undefined;
}


export interface IconSetArgs<D extends Id> {
   id: string;
   objects: D[];
   getSvg: (val: D) => string;
   getTitle: (val: D) => string;
}